import { render } from "./table-actions.vue?vue&type=template&id=4d55c6e6"
import script from "./table-actions.vue?vue&type=script&lang=js"
export * from "./table-actions.vue?vue&type=script&lang=js"

import "./table-actions.vue?vue&type=style&index=0&id=4d55c6e6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__